window.appConstants = {
    "AppName": "RKSamajam",
    "Allow": "RKS",
    "clicklogUrl": "https://fm6vmiafu6.execute-api.us-east-1.amazonaws.com/test/clicklogger",
    "audioUrl": "https://d1uxw61g8f505b.cloudfront.net",
    "enableClickLogs": true
    
}

